"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.formatUrl = function (url, params) {
  if (!params) {
    return url;
  }

  var replacedParams = new Set();
  var result = url.replace(/:[a-zA-Z]+/g, function (match) {
    var paramName = match.substr(1);

    if (params[paramName]) {
      replacedParams.add(paramName);
      return encodeURIComponent(String(params[paramName]));
    }

    return '';
  });
  var queryString = Object.keys(params).filter(function (paramName) {
    return !replacedParams.has(paramName);
  }).map(function (paramName) {
    return paramName + "=" + encodeURIComponent(String(params[paramName]));
  }).join('&');

  if (queryString) {
    result += url.includes('?') ? '&' : '?';
  }

  return result + queryString;
};